export default {"src":"/_next/static/media/WhoWeAre_035A.57fedc83.JPG","height":694,"width":1920};